var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-row hover", on: { click: _vm.onClick } },
    _vm._l(_vm.columns, function(column, colIndex) {
      return _c("TableCell", {
        directives: [
          {
            name: "profile-guard",
            rawName: "v-profile-guard",
            value: column.action,
            expression: "column.action"
          }
        ],
        key: colIndex,
        attrs: { column: column, data: _vm.data }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }